import Api from "./api";
export default {
  
     userAthenticate(loginid,password) {
      let apiurl = "userlogin/?format=json&loginid=" + loginid + "&password=" + password + "";
         return  Api.get(apiurl);
       },
       userExtraAthenticate(user_id,key,app_id) {
        let apiurl = "applogin/?user_id=" + user_id + "&key=" + key + "&app_id=" + app_id + "";
         return  Api.get(apiurl);
       },
       getloginuserapps(userid) {
        let apiurl = "user_app_url/?user_id=" + userid;
         return  Api.get(apiurl);
       },
}